<template>
  <div class="wrap">
    <div class="concent">
      <scroller>
        <div class="item-store"  v-for="(store, index) in stores"  :key="index">
          <div class="flex-row text-left" style="border-bottom: 1px solid #D8D8D8;">
            <div class="flex1 store-msg text-nowrap">
              <div class="text-nowrap font-1-1">{{store.name}}</div>
              <div class="text-nowrap font-0-6">{{store.address}}</div>
            </div>
            <!--<div class="text-center mapshow font-0-8" @click="bnGoMapClick(store)">-->
            <!--&lt;!&ndash;<div>{{store.distance_t}}</div>&ndash;&gt;-->
            <!--<div class="color-blue">地图</div>-->
            <!--</div>-->
          </div>
          <div class="flex-row store-option">
            <div class="flex1" @click="bookseat(store)">
              <img :src="store.bookseat" width="40px;"><br/>订座
            </div>
            <div class="flex1" @click="dineRoom(store)">
              <img :src="store.dineRoom" width="40px;"><br/>堂食/自提
            </div>
            <div class="flex1" @click="takeaway(store)">
              <img :src="store.takeaway" width="40px;"><br/>外卖
            </div>
            <a v-bind:href="'tel:'+store.telephone" class="flex1">
              <div >
                <img src="../../assets/image/phone.svg" width="40px;"><br/>电话
              </div>
            </a>
          </div>
        </div>
      </scroller>
    </div>

    <!--<div class="footer flex-row color_white">-->
    <!--<div class="flex1" @click="goWeiSite()">-->
    <!--<img src="../../assets/image/back.svg" height="22px;"><br/>回微官网-->
    <!--</div>-->
    <!--<div class="flex1"></div>-->
    <!--<div class="flex1"></div>-->
    <!--<div class="flex1" @click="bnMyBillClick()">-->
    <!--<div class="qty"></div>-->
    <!--<img src="../../assets/image/basket.svg" height="22px;"><br/>我的订单-->
    <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
  import ServiceHttp from "../../service/ServiceHttp";
  import ServiceDialog from "../../service/ServiceDialog";
  import ServiceUtils from "../../service/ServiceUtils";

  export default {
    name: "choose",
    data(){
      return {
        stores:[]
      }
    },
    components:{
    },
    methods:{
      /**
       * 返回微官网
       */
      goWeiSite(){
        let url = '{0}/weixin/{1}/oauth/index.html'.format(ServiceUtils.config.domain,ServiceUtils.config.sellerId);
        window.location.href = url;
      },
      /**
       * 我的订单
       */
      bnMyBillClick(){
        let url = '/bill/{0}'.format(ServiceUtils.config.sellerId);
        this.$router.replace({path:url});
      },
      /**
       * 查看地图
       */
      bnGoMapClick:function(store){
        let url = '/storemap/{0}/{1}/{2}/{3}/{4}/{5}'.format(ServiceUtils.config.sellerId,store.id,
          store.zoneName,store.address,store.distance_t,store.name);
        this.$router.replace({path:url});
      },
      /**
       * 订座
       */
      bookseat(store){
        // ServiceUtils.setStoreMsg(store);
        if (store.bookseatEnable === 0 || store.bookseatEnable === '0') {
          ServiceDialog.showAlert("温馨提示", "该门店尚未开通预订功能！");
          return;
        }
        let url = "{0}/weixin/{1}/vip/showCreateOrder/{2}.html".
        format(ServiceUtils.config.domain,ServiceUtils.config.sellerId,store.id);
        window.location.href=url;
      },
      /**
       * 堂食/自提
       */
      dineRoom:function(store){
        // ServiceUtils.setStoreMsg(store);
        ServiceUtils.config.storeName = store.name;
        if (store.dineRoomEnable === 0 || store.dineRoomEnable === '0') {
          ServiceDialog.showAlert("温馨提示", "该门店尚未开通堂食/自提功能！");
          return;
        }
        let isCheck = 1;  //是否该门店已点过菜
        if (store.id != ServiceUtils.config.storeId || ServiceUtils.config.orderType!= 0) {
          ServiceUtils.clearAllCacheData();                 //清理所有缓存数据
          isCheck = 1;
        } else {
          isCheck = 0;
        }
        ServiceUtils.changeTitle(store.name);
        let url = '/order/{0}/{1}/{2}/{3}'.format(ServiceUtils.config.sellerId,store.id,"0",isCheck);
        this.$router.replace({path:url});
      },
      /**
       * 外卖
       */
      takeaway(store){
        let isCheck = 1;
        if (store.takeawayEnable === 0 || store.takeawayEnable === '0') {
          ServiceDialog.showAlert("温馨提示", "该门店尚未开通外卖功能！");
          return;
        }
        ServiceUtils.config.storeName = store.name;
        ServiceUtils.config.sendRule = store.sendRule;
        ServiceUtils.config.sendAmount = store.sendAmount/100;
        ServiceUtils.config.distributionCharge = store.distributionCharge/100;

        if (store.id !== ServiceUtils.config.storeId || ServiceUtils.config.orderType!==2) {
            ServiceUtils.clearAllCacheData();
            isCheck = 1;
        } else {
            isCheck = 0;
        }
        let url = '/order/{0}/{1}/{2}/{3}'.format(ServiceUtils.config.sellerId,store.id,2,isCheck);
        this.$router.replace({path:url});

//        let _str = '<div style="text-align: left;font-size: 0.8em;"> ' +
//          '1、本店起送金额'+store.sendAmount/100+'元;<br>' +
//          '2、本店外送范围'+store.sendDistance+'米;<br>' +
//          ' 3、本店配送费'+store.distributionCharge/100+'元<br>' +
//          '4、本店消费满'+store.sendRule/100+'元免配送费;<br>' +
//          ' 5、为保证及时送餐，请在营业高峰之前下单。</div>';
//        ServiceDialog.confirm('温馨提示',_str,()=>{
//          if (store.id !== ServiceUtils.config.storeId || ServiceUtils.config.orderType!==2) {
//            ServiceUtils.clearAllCacheData();
//            isCheck = 1;
//          } else {
//            isCheck = 0;
//          }
//          let url = '/order/{0}/{1}/{2}/{3}'.format(ServiceUtils.config.sellerId,store.id,2,isCheck);
//          this.$router.replace({path:url});
//        })
      },


      //创建门店数据
      createStoreData :function(storeData) {
        let stores = [];
        if (Array.isArray(storeData)) {
          for (var i = 0; i < storeData.length; ++i) {
            let v = storeData[i];
            let dis = Number(v.distance);
            if (dis > 1000000) {
              v.distance_t = "无法判断距离";
            } else if (dis >= 1000) {
              v.distance = dis / 1000;
              v.distance_t = `距您${v.distance}km`;
            } else {
              v.distance_t = `距您${v.distance}m`;
            }
            let _enable = v.isEnable+'';
            v.dineRoom = 'static/image/tangshi-grey.svg';
            v.bookseat = 'static/image/bookseat-grey.svg';
            v.takeaway = 'static/image/takeaway-grey.svg';
            v.dineRoomEnable = 0;
            v.bookseatEnable = 0;
            v.takeawayEnable = 0;
            if(_enable=='0'){
              stores.push(v);
            }else if(_enable=='9'){
              v.dineRoom = 'static/image/tangshi.svg';
              v.bookseat = 'static/image/bookseat.svg';
              v.takeaway = 'static/image/takeaway.svg';
              v.dineRoomEnable = 1;
              v.bookseatEnable = 1;
              v.takeawayEnable = 1;
              stores.push(v);
            }else{
              if(_enable.indexOf('1')>=0){
                v.dineRoom = 'static/image/tangshi.svg';
                v.dineRoomEnable = 1;
              }
              if(_enable.indexOf('2')>=0){
                v.takeaway = 'static/image/takeaway.svg';
                v.takeawayEnable = 1;
              }
              if(_enable.indexOf('3')>=0){
                v.bookseat = 'static/image/bookseat.svg';
                v.bookseatEnable = 1;
              }
              stores.push(v);
            }
          }
        } else {
          stores =[];
        }
        return stores
      },

    },
    mounted(){

      let params = this.$route.params ;      //url参数
      ServiceUtils.config.sellerId = params.sellerId;
      ServiceHttp.getStoreData((res)=>{
        if(res){
          let stores = this.createStoreData(res.storefront);

          if(stores.length==0){
            ServiceDialog.showAlert("温馨提示", "未获得任何门店信息!");
          }else {
            this.stores.length = 0;
            this.stores=stores;
            ServiceUtils.stores.length  =0 ;
            ServiceUtils.stores.append(stores);
          }
        }
      });
    },
  }
</script>

<style scoped  lang="scss">
  @import "../../assets/css/style";
  .concent{
    position: absolute;
    top:0;
    bottom: 0;
    left:0;
    right: 0;
  }
  .footer{
    position: absolute;
    height: 55px;
    bottom: 0;
    left:0;
    right: 0;
    background: rgba(0,0,0,.8);
  }
  .item-store:first-child{
    background-color: $color_white;
    margin-top: 0;
  }
  .item-store{
    background-color: $color_white;
    margin-top: 10px;
  }
  .store-msg{
    padding: 15px 10px;
    border-right: 1px solid #D8D8D8;
  }
  .mapshow{
    width: 130px;
  }
  .store-option{
    padding: 5px 0;
    background-color: #F1F1F1;
    color: #666;
  }
  .qty{
    width: 10px;
    height:10px;
    border-radius: 5px;
    background-color: red;
    position: absolute;
    bottom: 40px;
    right: 5px;
  }
  a{
    text-decoration:none;
    color: #707070
  }
</style>



// WEBPACK FOOTER //
// src/components/routerPages/choose.vue